import React, { useRef, Fragment } from 'react'
import * as fallbackImage from '../../../../images/default-fallback-image.png';
import getImageUrl, { getFeaturedImage, getImages } from '../../../util/getImage'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination } from 'swiper/modules'

export default function Card({ restaurant, view }) {

  const swiperInstanceRef = useRef(null)

  const goNext = () => {
    const swiper = swiperInstanceRef.current
    if (swiper) {
      if ( getImages(restaurant.images).length < swiper.realIndex + 2 ) {
        swiper.slideToLoop(0)
        return
      }
      swiper.slideNext()
    }
  }

  const getImage = () => {
    const restaurantImages = getImages(restaurant.images)
    if ( !restaurantImages || restaurantImages.length === 0 ) {
      return (
        <div className="h-objectImage js-objectImage h-objectImage--3by2 visible">
          <img className="l-card__image" src={`${fallbackImage}`} />
        </div>
      )
    }
    if ( restaurantImages.length === 1 ) {
      return (
        <div className="h-objectImage js-objectImage h-objectImage--3by2 visible">
          <img className="l-card__image" src={`${getImageUrl(getFeaturedImage(restaurantImages), 'default', '559x327' )}`} />
        </div>
      )
    }
    return initSlider(restaurantImages)
  }

  const initSlider = (images) => {
    return (
      <Swiper
        modules={[Pagination]}
        loop={true}
        pagination={{
          type: 'bullets',
          clickable: true,
        }}
        onSwiper={(swiper) => { swiperInstanceRef.current = swiper }}
      >
        {
          images.map( ( image, index ) => (
            <SwiperSlide className="c-searchCard__slideWrapper" key={index}>
              <div className="c-searchCard__slide">
                {
                  view === 'mapCard' ? (
                    <img className="l-card__image" src={`${getImageUrl(image, 'default', '559x327' )}`} />
                  ) : (
                    <img className="l-card__image" loading="lazy" src={`${getImageUrl(image, 'default', '559x327')}`} />
                  )
                }
              </div>
            </SwiperSlide>
          ))
        }
      </Swiper>
    )
  }

  const getCuisines = ( cuisines ) => {
    let cuisinesString = ''
    cuisines.map( (cuisine, index) => {
      cuisinesString += ( index !== 0 ? ', ' : '') +  cuisine['description']
    })
    return cuisinesString && (
      <li className="h-icon-text">
        <i className="icon ion-ios-restaurant"></i>
        { cuisinesString }
      </li>
    )
  }

  const getAwards = ( awards ) => {
    let counter = 0
    let awardsString = ''
    awards.map( award => {
      if ( award.pivot.score > 0 ) {
        counter++

        if ( award['name'] === 'Michelin Green Star' ) {
          awardsString += ( counter !== 1 ? ', ' : '') + award['name']
        } else if ( award['name'] != 'Les Grandes Tables du Monde' ) {
          awardsString += ( counter !== 1 ? ', ' : '') + ( award['pivot']['score'] + ' ' ) + award['name']
        } else {
          awardsString += ( counter !== 1 ? ', ' : '' ) + award['name']
        }
      }
    })
    return awardsString && (
      <li className="h-icon-text mb-0">
        <i className="icon ion-md-trophy"></i>
        { awardsString }
      </li>
    )
  }

  const getDistance = (type) => {
    if( restaurant.distance ) {
      let distanceValue = parseFloat(restaurant.distance).toFixed(2)
      distanceValue = Math.round(distanceValue * 2) / 2
      let text = 'miles away'
      if ( type === 'grid' || type === 'map' ) {
        text += ', '
        return ( distanceValue + ' ' + text )
      }
    return <div className="c-searchCard__distance">{distanceValue} {text}</div>
    }
  }

  if ( view === 'grid' ) {
    return (
      <div className="col-6">
        <a className="c-restaurantCard c-searchCard c-searchCard--grid" href={`/restaurant/${restaurant.slug}`}>
          <div className="c-restaurantCard__image">
            {getImage()}
          </div>
          <div className="c-restaurantCard__body c-searchCard__body l-box l-box--lightShadow">
            <h2 className="c-restaurantCard__title c-searchCard__title h4">{ restaurant.name }</h2>
            <ul>
              <li className="h-icon-text">
                  <i className="icon ion-ios-pin"></i>
                  { getDistance('grid') }
                  { restaurant.addr_line_1 ? ( restaurant.addr_line_1 + ', ' )  : '' }
                  { restaurant.addr_city ? ( restaurant.addr_city + ', ' )  : '' }
                  { restaurant.addr_county ? restaurant.addr_county  : '' }
              </li>
              { getCuisines(restaurant['cuisines']) }
              { getAwards(restaurant['awards']) }
            </ul>
            {
              restaurant.limited_edition_bool || restaurant.club_access ? <div className={`c-searchCard__clubOfferLabel${restaurant.club_access ? ' c-searchCard__clubOfferLabel--clubAccess' : ''}`}>{restaurant.club_access ? 'Club access' : 'Club offer'}</div> : <span />
            }
          </div>
        </a>
      </div>
    )
  }

  if ( view === 'mapCard' ) {
    return (
      <a className="c-restaurantCard c-searchCard c-searchCard--map" href={`/restaurant/${restaurant.slug}`}>
        <div className="c-restaurantCard__image">
          {getImage()}
        </div>
        <div className="c-restaurantCard__body c-searchCard__body l-box l-box--lightShadow">
          <h2 className="c-restaurantCard__title c-searchCard__title h4">{ restaurant.name }</h2>
          <ul>
            <li className="h-icon-text">
                <i className="icon ion-ios-pin"></i>
                { getDistance('map') }
                { restaurant.addr_line_1 ? ( restaurant.addr_line_1 + ', ' )  : '' }
                { restaurant.addr_city ? ( restaurant.addr_city + ', ' )  : '' }
                { restaurant.addr_county ? restaurant.addr_county  : '' }
            </li>
            { getCuisines(restaurant['cuisines']) }
            { getAwards(restaurant['awards']) }
          </ul>
          {
            restaurant.limited_edition_bool || restaurant.club_access ? <div className={`c-searchCard__clubOfferLabel${restaurant.club_access ? ' c-searchCard__clubOfferLabel--clubAccess' : ''}`}>{restaurant.club_access ? 'Club access' : 'Club offer'}</div> : <span />
          }
        </div>
      </a>
    )
  }

  if ( view === 'list' ) {
    return (
      <a className="c-searchCard__wrapper c-searchCard__wrapper--list col-12" href={`/restaurant/${restaurant.slug}`}>
        <div className="c-searchCard c-searchCard--list">
          <div className="c-restaurantCard__image c-searchCard__image">
            <div className="h-objectImage js-objectImage h-objectImage--3by2 visible">
              {getImage()}
            </div>
          </div>
          <div className="c-restaurantCard__body c-searchCard__body l-box l-box--lightShadow">
            { getDistance() }
            <h2 className="c-restaurantCard__title c-searchCard__title h3">{ restaurant.name }</h2>
            <ul>
              <li className="h-icon-text">
                <i className="icon ion-ios-pin"></i>
                { restaurant.addr_line_1 ? ( restaurant.addr_line_1 + ', ' )  : '' }
                { restaurant.addr_city ? ( restaurant.addr_city + ', ' )  : '' }
                { restaurant.addr_county ? restaurant.addr_county  : '' }
              </li>
            </ul>
            <ul className="c-searchCard__detailsWrapper d-flex">
              { getAwards(restaurant['awards']) }
              { getCuisines(restaurant['cuisines']) }
            </ul>
            {
              restaurant.limited_edition_bool || restaurant.club_access ? <div className={`c-searchCard__clubOfferLabel${restaurant.club_access ? ' c-searchCard__clubOfferLabel--clubAccess' : ''}`}>{restaurant.club_access ? 'Club access' : 'Club offer'}</div> : <span />
            }
          </div>
        </div>
      </a>
    )
  }

}
